import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityPaisesDocumentoState,
  entityPaisesDocumentoAdapter
} from './paises-documento.state';
import {
  entityPaisesDocumentoLoadFailure,
  entityPaisesDocumentoLoadRequest,
  entityPaisesDocumentoLoadSuccess
} from './paises-documento.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityPaisesDocumentoLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPaisesDocumentoLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPaisesDocumentoLoadSuccess, (state, { items }) =>
    entityPaisesDocumentoAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function paisesDocumentoReducer(
  state: EntityPaisesDocumentoState,
  action: Action
) {
  return reducer(state, action);
}
